module.exports = __webpack_public_path__ + "static/media/fifa.6b2161e4.svg";